import React, { useState, useEffect } from 'react'
import { Button, Input, Card, Typography, message, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { getAccessToken, signOut } from '../services/auth'
import deviceApi from '../services/api'

const { Title } = Typography

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

function Login() {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [isSignUp, setIsSignUp] = useState(false)

    // 检查登录态，已登录则跳转
    // 只有 token 真的能通过后端校验才跳转，光看 localStorage 里有没有值不够：
    // 过期或签名不匹配的 token 会让业务页 401 后又被跳回来，形成死循环
    useEffect(() => {
        let cancelled = false
        getAccessToken().then(async token => {
            if (!token) return
            try {
                await deviceApi.getMyProfile()
                if (!cancelled) {
                    navigate('/edit', { replace: true })
                }
            } catch (err) {
                await signOut()
            }
        })
        return () => { cancelled = true }
    }, [navigate])

    const handleSubmit = async () => {
        if (!email || !password) {
            message.warning('请输入用户名或邮箱和密码')
            return
        }

        setLoading(true)
        try {
            const url = isSignUp ? '/api/auth/register' : '/api/auth/login'
            const resp = await fetch(`${API_BASE_URL}${url}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            })
            const data = await resp.json()
            if (data.success) {
                localStorage.setItem('utimes_token', data.data.token)
                message.success(isSignUp ? '注册成功' : '登录成功')
                navigate('/edit')
            } else {
                message.error(data.message || '操作失败')
            }
        } catch (err) {
            message.error('操作失败: ' + err.message)
        } finally {
            setLoading(false)
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit()
        }
    }

    return (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '40px',
        gap: '300px',
    }}>
        {/* 左侧介绍 */}
        <div style={{ maxWidth: 400 }}>
            <h1 style={{
                fontSize: 76,
                marginTop: -50,
                marginBottom: 40,
                color: '#19191a',
                
            }}>
                UTimes
            </h1>
            <p style={{
                fontSize: 18,
                color: '#19191a',

                opacity: 0.95,
            }}>
                一个用于记录个人日常生活的笔记网站
            </p>
        </div>

        {/* 右侧登录卡片 */}
        <Card style={{ 
            width: 360,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        }}>
            <Title level={3} style={{ textAlign: 'center', marginBottom: 24 }}>
                UTimes
            </Title>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Input
                    placeholder="用户名或邮箱"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    onKeyDown={handleKeyDown}
                    size="large"
                />
                <Input.Password
                    placeholder="密码"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                    size="large"
                />
                <Button
                    type="primary"
                    block
                    size="large"
                    loading={loading}
                    onClick={handleSubmit}
                >
                    {isSignUp ? '注册' : '登录'}
                </Button>
                <div style={{ textAlign: 'center' }}>
                    <span
                        style={{ cursor: 'pointer', color: '#1677ff' }}
                        onClick={() => setIsSignUp(!isSignUp)}
                    >
                        {isSignUp ? '已有账号？去登录' : '没有账号？去注册'}
                    </span>
                </div>
            </Space>
        </Card>
    </div>
)
}

export default Login
